import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-cycle
import { CompareTableModalConnector } from "../CompareTable";
// eslint-disable-next-line import/no-cycle
import { WeddingFormConnector } from "../WeddingForm";
import { VacationFinderConnector } from "../VacationFinder";
import { SeatMapConnector } from "../SeatMap";
// eslint-disable-next-line import/no-cycle
import { TableConnector } from "../Table/TableConnector";
// eslint-disable-next-line import/no-cycle
import { LPCConnector } from "../LPCSearch/LPCConnector";
import { HashTagConnector } from "../HashTag/HashTagConnector";
// eslint-disable-next-line import/no-cycle
import { SignUpFormConnector } from "../SignUpForm";
// eslint-disable-next-line import/no-cycle
import { EmailAcquisitionConnector } from "../EmailAcquisitionForm";
import { BookingSearchBox } from "../Header/BookingSearchBox";
import { BlackFridayFormConnector } from "../BlackFridayForm";
import { FormAssemblyConnector } from "../FormAssembly";

const ComponentBlock = ({ data, locale }) => {
	const content = data?.configuration && JSON.parse(data?.configuration?.internal?.content);
	const lang = locale?.split("-")[0] === "fr" ? "fr" : "en";

	switch (data?.componentType) {
		case "compare-table":
			return <CompareTableModalConnector data={content} />;
		case "wedding-form":
			return <WeddingFormConnector data={content} />;
		case "vacation-finder":
			return <VacationFinderConnector locale={locale} />;
		case "seat-map":
			return <SeatMapConnector data={content} />;
		case "table":
			return <TableConnector data={content} />;
		case "lpc":
			return <LPCConnector data={content} />;
		case "hash-tag":
			return <HashTagConnector data={content} />;
		case "signup-form":
			return <SignUpFormConnector data={content} lang={lang} />;
		case "signup-form-assembly":
			return <EmailAcquisitionConnector data={content} lang={lang} />;
		case "search-box":
			return <BookingSearchBox lang={data.lang} type={data.type} />;
		case "black-friday":
			return <BlackFridayFormConnector data={content} />;
		case "form-assembly":
			return <FormAssemblyConnector data={content} />;
		default:
			return <></>;
	}
};

/* Declare page prop */
ComponentBlock.propTypes = {
	data: PropTypes.object.isRequired,
	locale: PropTypes.string,
};

ComponentBlock.defaultProps = {
	locale: "en",
};

export default ComponentBlock;
export { ComponentBlock };
